import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './shared/components/toast-container/toast-container.component';
import { VaultNoticeHostComponent } from './components/vault/notices/vault-notice-host.component';
import { VaultConfirmDialogComponent } from './components/vault/notices/vault-confirm-dialog.component';

@Component({
  selector: 'app-root',
  standalone: true,
  // The two vault hosts sit here rather than in VaultShellComponent because their messages have to
  // outlive it: removing a person navigates away from the page that did it, and the sign-in route
  // sits outside the shell entirely. Both render nothing while their state is empty, so they are
  // inert on committee routes — and they are two lines to delete along with the rest of the vault.
  imports: [RouterOutlet, ToastContainerComponent, VaultNoticeHostComponent, VaultConfirmDialogComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Committee Management System';
}
